import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { UserProfile } from '../models/user-profile.model';

@Injectable({
  providedIn: 'root'
})
export class ContactService {

  constructor(
    private http: HttpClient
  ) { }

  createContact(item): Observable<any> {
    return this.http
      .post<any>(environment.apiUrl + '/api/contacts/create', JSON.stringify(item));
  }

  getContacts(): Observable<any> {
    return this.http
      .get<UserProfile>(environment.apiUrl + '/v2/account/user-contact');
  }

  favorite(item): Observable<any> {
    return this.http
      .post<any>(environment.apiUrl + '/api/contacts/favorite', JSON.stringify(item));
  }
}
